import { ApiProperty } from '@nestjs/swagger';
import { BoardTypeInterface } from '../interfaces/board-type.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import {
  ArrayNotEmpty,
  ArrayUnique,
  IsBoolean,
  IsEnum,
  IsNumber,
  IsString,
  MaxLength,
  MinLength,
} from 'class-validator';
import { Exclude, Expose, Type } from 'class-transformer';
import { ContractorResourceTypeEnum } from '../../contractor/enums/contractor-resource-type.enum';

@Exclude()
export class BoardTypeDto
  extends CommonEntityDto
  implements BoardTypeInterface
{
  @ApiProperty({
    title: 'External ID',
    description: 'Identifier manually carried over from external system.',
  })
  @IsString()
  @MinLength(1)
  @MaxLength(100)
  @Expose()
  externalId!: string;

  @ApiProperty({
    title: 'Name',
    description: 'The name of the Board Type',
  })
  @IsString()
  @MinLength(2)
  @MaxLength(100)
  @Expose()
  name!: string;

  @ApiProperty({
    title: 'Sort Priority',
    description: 'The sort order of the board type.',
  })
  @Expose()
  @Type(() => Number)
  @IsNumber()
  sortPriority!: number;

  @ApiProperty({
    title: 'Short Name',
    description: 'The "short name" of the Board Type',
  })
  @IsString()
  @MinLength(2)
  @MaxLength(50)
  @Expose()
  shortName!: string;

  @ApiProperty({
    title: 'Labor Only',
    description: 'True if the board type only applies to labor only Jobs.',
    default: false,
  })
  @IsBoolean()
  @Type(() => Boolean)
  @Expose()
  laborOnly!: boolean;

  @ApiProperty({
    title: 'Description',
    description: 'The description of the Board Type',
  })
  @IsString()
  @MinLength(1)
  @MaxLength(500)
  @Expose()
  description!: string;

  @ApiProperty({
    type: 'enum',
    enum: ContractorResourceTypeEnum,
    isArray: true,
    title: 'Payable Contractor Types',
    description: 'Array of contractor types that get paid for this board type.',
  })
  @ArrayNotEmpty({
    message: 'Please provide at least one payable contractor type.',
  })
  @ArrayUnique()
  @IsEnum(ContractorResourceTypeEnum, { each: true })
  @Expose()
  payableResourceTypes!: ContractorResourceTypeEnum[];
}
